import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; 

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

// 引入 jQuery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import "@/assets/css/style.css"; 
import "@/assets/sass/stylesupport.css";

import "@/assets/js/javascript.js";

const app = createApp(App);
app.use(router);
app.mount('#app');
